





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { AttachmentFile } from '@/models/attachmentFile';

@Component
export default class ChatForm extends Vue {
  @Prop({ required: true }) private applyEvent: string;

  private imageList = new Array<AttachmentFile>();

  private message = '';

  private onSelectUploadFile(file: any) {
    if (/image\//.test(file.raw.type)) {
      this.imageList.push({
        url: null,
        name: file.name,
        localUrl: file.url,
        isDelete: false,
        raw: file.raw,
      });
    } else {
      this.$notify.error({
        title: 'ファイル選択エラー',
        message: '画像ファイルのみ選択可能です。',
        position: 'bottom-right'
      });
    }
  }

  private onDeleteImage(file: AttachmentFile) {
    if (!file.url) {
      const index = this.imageList.findIndex((item) => {
        return item.localUrl === file.localUrl;
      });
      if (index >= 0) {
        this.imageList.splice(index, 1);
      }
    } else {
      const target = this.imageList.find((item) => {
        return item.url === file.url;
      });
      if (!!target) {
        target.isDelete = true;
      }
    }
  }

  private onSubmit() {
    this.$emit(this.applyEvent, {
      message: this.message,
      imageList: this.imageList,
    });
    this.message = '';
    this.imageList = [];
  }
}
